// Add flows here
const ChangeOfTenancy = () =>
  import("./changeOfTenancy/changeOfTenancyFlowConfig")
const IssueBill = () => import("./issueBill/issueBillFlowConfig")
const ImbpQuestions = () => import("./imbpQuestions/imbpQuestionsFlowConfig")
const ImbpBooking = () => import("./imbpBooking/imbpBookingFlowConfig")
const ImbpBookingNew = () => import("./imbpBookingNew/imbpBookingNewFlowConfig")
const Deceased = () => import("./deceased/deceasedFlowConfig")
const RefundReview = () => import("./refundReview/refundReviewFlowConfig")
const ReviewPaymentAmount = () =>
  import("./reviewPaymentAmount/reviewPaymentAmountFlowConfig")
const Spayg = () => import("./smartPayAsYouGo/spaygFlowConfig")

export enum FlowType {
  ChangeOfTenancy = "changeOfTenancy",
  IssueBill = "issueBill",
  ImbpQuestions = "imbpQuestions",
  ImbpBooking = "imbpBooking",
  ImbpBookingNew = "imbpBookingNew",
  Deceased = "deceased",
  RefundReview = "refundReview",
  ReviewPaymentAmount = "reviewPaymentAmount",
  Spayg = "smartPayAsYouGo",
}

export default {
  [FlowType.ChangeOfTenancy]: ChangeOfTenancy,
  [FlowType.IssueBill]: IssueBill,
  [FlowType.ImbpQuestions]: ImbpQuestions,
  [FlowType.ImbpBooking]: ImbpBooking,
  [FlowType.ImbpBookingNew]: ImbpBookingNew,
  [FlowType.Deceased]: Deceased,
  [FlowType.RefundReview]: RefundReview,
  [FlowType.ReviewPaymentAmount]: ReviewPaymentAmount,
  [FlowType.Spayg]: Spayg,
}
